import { createSlice } from '@reduxjs/toolkit'

const authSlice = createSlice({
    name: 'auth',
    initialState: { isAuthorized: false },
    reducers: {
        setAuthorized(state, action) {
            const { payload } = action

            state.isAuthorized = payload
        },
    },
})

const { actions, reducer } = authSlice

export const { setAuthorized } = actions

export default reducer
